/**
 * "Don't know where to get started?" card on the FA dashboard (Feature 137, replacing Feature
 * 106's "Have a question first?").
 *
 * The no-fee path, sitting beside the paid one. An advisor with a client waiting will not fill out
 * a form, so the free 15-minute service coordination call leads; the Care Concierge contact form
 * the QA tab already opens stays as the fallback, under its own page origin so the concierge team
 * can tell this card apart from the care seeker's.
 */

import { useState } from 'react';
import { MessageCircleQuestion } from 'lucide-react';
import { Card } from '@/shared/components/ui/card';
import { Button } from '@/shared/components/ui/button';
import { ServiceCoordinationCallButton } from '@/shared/components/ServiceCoordinationCallButton';
import { ConciergeContactModal } from '../qa-tab/ConciergeContactModal';

export const ServiceCoordinationCallCard = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <Card className="flex flex-col gap-3 p-4">
      <div className="flex items-center gap-2">
        <MessageCircleQuestion className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
        <h3 className="font-medium">Don&rsquo;t know where to get started?</h3>
      </div>

      <p className="text-sm text-gray-600">
        Start with a free 15-minute service coordination call with our Care Concierge team. No
        charge, and no session is used.
      </p>

      <div className="mt-auto flex flex-wrap items-center gap-2">
        <ServiceCoordinationCallButton variant="default" size="sm" />
        <Button type="button" size="sm" variant="link" onClick={() => setIsFormOpen(true)}>
          Or send us a question
        </Button>
      </div>

      <ConciergeContactModal
        open={isFormOpen}
        onOpenChange={setIsFormOpen}
        pageOrigin="fp-dashboard-card"
        offerCall={false}
      />
    </Card>
  );
};
